export enum IncomingInvoiceStatus {
  New = 1,
  PartiallyBooked = 2,
  Booked = 3,
  Protested = 4,
  Pending = 5,
  Open = 6
}
